import { useSession } from "@/frontend/lib/auth";
import { usePushNotifications } from "@/frontend/hooks/usePushNotifications";

interface PushNotificationReconcilerProps {
  organizationId: string | null;
}

/**
 * Keeps the current browser's push subscription synchronized whenever the
 * authenticated application shell is mounted, regardless of the active page.
 */
export function PushNotificationReconciler({
  organizationId,
}: PushNotificationReconcilerProps) {
  const { data: session } = useSession();
  usePushNotifications(organizationId, session?.user?.id ?? null);
  return null;
}
